import axios from "./request"

export default {
  async get(query) {
    query.type = 3
    return (await axios.get('/extra-services', {
      params: query
    })).data
  }
}
